/*
 * Public API Surface of user profile
 */
export * from './user-profile.module';
